import absTheme from './abs';
import apprizeTheme from './apprize';
import gustoTheme from './gusto';
import helixTheme from './helix';
import nationwideTheme from './nationwide';
import proficientTheme from './proficient';
import ripplingTheme from './rippling';
import rmrTheme from './rmr';
import { WhiteLabelTheme } from './types';

const QUERY_KEY = 'whiteLabeling';

const { search } = window.location;
const envVariable = import.meta.env.REACT_APP_WHITE_LABEL;
const query = new URLSearchParams(search).get(QUERY_KEY);
export const THEMES = {
  rmr: 'admin-rmr',
  proficient: 'admin-proficient',
  apprize: 'admin-apprize',
  rippling: 'admin-rippling',
  abs: 'admin-abs',
  helix: 'admin-helix',
  gusto: 'admin-gusto',
  nationwide: 'admin-nationwide',
};

export const isThemeApplied = (key: string) => {
  return query === key || envVariable === key || sessionStorage.getItem(key);
};

const TRUE_KEY = 'true';

const getTheme = () => {
  let currentTheme: WhiteLabelTheme | null = null;
  let key = '';
  if (isThemeApplied(THEMES.rmr)) {
    currentTheme = rmrTheme;
    key = THEMES.rmr;
    sessionStorage.setItem(THEMES.rmr, TRUE_KEY);
  }
  if (isThemeApplied(THEMES.apprize)) {
    currentTheme = apprizeTheme;
    key = THEMES.apprize;
    sessionStorage.setItem(THEMES.apprize, TRUE_KEY);
  }
  if (isThemeApplied(THEMES.proficient)) {
    currentTheme = proficientTheme;
    key = THEMES.proficient;
    sessionStorage.setItem(THEMES.proficient, TRUE_KEY);
  }
  if (isThemeApplied(THEMES.abs)) {
    currentTheme = absTheme;
    key = THEMES.abs;
    sessionStorage.setItem(THEMES.abs, TRUE_KEY);
  }
  if (isThemeApplied(THEMES.rippling)) {
    currentTheme = ripplingTheme;
    key = THEMES.rippling;
    sessionStorage.setItem(THEMES.rippling, TRUE_KEY);
  }
  if (isThemeApplied(THEMES.helix)) {
    currentTheme = helixTheme;
    key = THEMES.rippling;
    sessionStorage.setItem(THEMES.helix, TRUE_KEY);
  }
  if (isThemeApplied(THEMES.gusto)) {
    key = THEMES.gusto;
    sessionStorage.setItem(THEMES.gusto, TRUE_KEY);
    return { key, ...gustoTheme } as WhiteLabelTheme;
  }
  if (isThemeApplied(THEMES.nationwide)) {
    currentTheme = nationwideTheme;
    key = THEMES.nationwide;
    sessionStorage.setItem(THEMES.nationwide, TRUE_KEY);
  }
  if (!currentTheme) {
    return {} as WhiteLabelTheme;
  }

  if (currentTheme.title) {
    document.title = currentTheme.title;
  }
  return {
    key: envVariable || query || key,
    title: currentTheme.title?.toLowerCase(),
    loginIconWidth: currentTheme?.loginIconWidth,
    loginScreenTitle: currentTheme?.loginScreenTitle,
    loginIconHeight: currentTheme?.loginIconHeight,
    colors: currentTheme.colors || {},
    fonts: currentTheme?.fonts || {},
    logo: currentTheme.logo,
    minifyLogo: currentTheme.minifyLogo,
    images: currentTheme.images || {},
    font: currentTheme.font,
    titleFont: currentTheme.titleFont,
    rounds: currentTheme.rounds || {},
    favicon: currentTheme.favicon || '',
    favicon16: currentTheme.favicon16 || '',
    favicon32: currentTheme.favicon32 || '',
    faviconAppleTouch: currentTheme.faviconAppleTouch || '',
    shadows: currentTheme.shadows || {},
  } as WhiteLabelTheme;
};

export default getTheme();
